import timer_gen_2 from '@devices/settings/device_settings/timer_gen_2.js';
import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2.js';
import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import scripts_gen_2 from '@devices/settings/device_settings/scripts_gen_2.js';
import networks_gen_2_plus from '@devices/settings/device_settings/networks_gen_2_plus.js';
import app_setting_gen_2 from '@devices/settings/device_settings/app_setting_gen_2.js';
import share from '@devices/settings/device_settings/share.js';
import bluetooth_gen_2 from '@devices/settings/device_settings/bluetooth_gen_2.js';

export default {
	name: 'Shelly1Mini',
	friendly_name: 'Plus 1 Mini',
	family: 'relay',
	reset_from_input: true,
	isPM: false,
	modes: {
		relay: {
			channels: 1,
			notifications: ['offline', 'device_problem', 'forgotten_lights', 'overtemperature'],
			settings: [
				timer_gen_2,
				schedule_gen_2,
				webhooks_gen_2,
				scripts_gen_2,
				networks_gen_2_plus,
				bluetooth_gen_2,
				app_setting_gen_2,
				share,
				{
					title: 'settings',
					components: [
						{ title: 'eco_mode', component: 'eco_mode_g2' },
						{ title: 'input_output', component: 'input_output_g2' },
						{
							title: 'enable_input',
							component: 'enable_input_g2',
							min_ver: '1.0.7',
						},
						{
							title: 'lock_inputs',
							component: 'lock_inputs_g2',
							min_ver: '1.6.0',
						},
						{ title: 'invert_switch', component: 'invert_switch_g2' },
						{ title: 'device_name', component: 'device_name_g2' },
						{ title: 'input_name', component: 'input_name_g2' },
						{ title: 'firmware_version', component: 'firmware_update' },
						{ title: 'geo_location_and_time_zone', component: 'location_g2' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'factory_reset', component: 'factory_reset' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
		},
	},
};
